<template>
  <Card>
    <HeadingMedium
      :class="$style.headerBorder"
      hasMargin
    >
      {{ userConfig.title }}
      <Icon
        icon="info"
      />
    </HeadingMedium>
    <ParagraphBody>
      <MarkdownInline :mdTemplate="userConfig.configBodyText" />
    </ParagraphBody>
    <template v-slot:footer>
      <GoogleEmmDynamicSelectModal />
    </template>
  </Card>
</template>

<script>
import { AndroidEmmConsts } from 'client/util/Constants';
import {
  Card,
  HeadingMedium,
  Icon,
  MarkdownInline,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import GoogleEmmDynamicSelectModal from 'client/MDM/components/GoogleEmmDynamicSelectModal.vue';

export default {
  name: 'GoogleEmmUserConfig',

  components: {
    Card,
    GoogleEmmDynamicSelectModal,
    HeadingMedium,
    Icon,
    MarkdownInline,
    ParagraphBody,
  },

  data: () => ({
    userConfig: AndroidEmmConsts.androidEmmUserConfigText,
  }),
};
</script>

<style module>
.headerBorder {
  border-bottom: var(--jc-border);
  padding-bottom: var(--jc-spacer);
}

.headerBorder span svg {
  margin-left: 0.75rem;
  margin-top: var(--jc-spacer-x-small);
  position: absolute;
}
</style>
